import React, { useEffect, useRef } from "react";

// const CONNECT_INSTANCE_URL = "https://ws0122-stage.my.connect.aws";

export default function DialPad() {
    const ccpContainer = useRef(null);

    useEffect(() => {
        if (!window.connect || !ccpContainer.current) return;

        window.connect.core.initCCP(ccpContainer.current, {
            ccpUrl: `${process.env.REACT_APP_CONNECT_INSTANCE_URL }/ccp-v2/`,
            loginPopup: true,
            loginPopupAutoClose: true,
            loginOptions: {
            autoClose: true,
            height: 600,
            width: 400,
        },
            softphone: {
            allowFramedSoftphone: true,
        },
    });
}, []);

return (
    <div
        ref={ccpContainer}
        style={{
            margin: "auto",
            width: "400px",
            height: "700px",
        }}
    />
);
}